import axiosInstance from "../services/axiosInstance";

export const googleAuth = async (payload) => {

    try {
        const response = await axiosInstance.post('../auth/signin-with-google',payload,{
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data;
    } catch (error) {
        throw new Error(error.message);
    }
}